/**
 * @generated SignedSource<<642924bee84a2300173344df8ce47d47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodPaymentDeadline_charge$data = {
  readonly company: {
    readonly id: string;
    readonly nameFriendly: string | null | undefined;
    readonly preferences: {
      readonly chargeSettings: {
        readonly expiration: {
          readonly fakeValue: number | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly createdAt: string | null | undefined;
  readonly expiresDate: string | null | undefined;
  readonly " $fragmentType": "PaymentMethodPaymentDeadline_charge";
};
export type PaymentMethodPaymentDeadline_charge$key = {
  readonly " $data"?: PaymentMethodPaymentDeadline_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodPaymentDeadline_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodPaymentDeadline_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyPreferencesCharge",
              "kind": "LinkedField",
              "name": "chargeSettings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ChargeExpiration",
                  "kind": "LinkedField",
                  "name": "expiration",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fakeValue",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "c657635b0519741d1c2f833dfe600261";

export default node;
